import { RichTextDocument } from "@hex/common";
import React from "react";
import styled from "styled-components";

import { useUniqueId } from "../../hooks/useUniqueId";
import { PlateRichTextEditor } from "../rich-text/PlateRichTextEditor";

export interface CommentTextProps {
  readonly commentRichText: RichTextDocument;
  readonly className?: string;
}

const PlateCommentText = styled(PlateRichTextEditor)`
  font-size: ${({ theme }) => theme.fontSize.DEFAULT};
`;

export const CommentText: React.ComponentType<CommentTextProps> = React.memo(
  function CommentText({ className, commentRichText }: CommentTextProps) {
    const editorId = useUniqueId();
    return (
      <PlateCommentText
        className={className}
        id={editorId}
        initialValue={commentRichText}
        readOnly={true}
      />
    );
  },
);
